import React, { useMemo } from "react";
import { Box, Button } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import TagsDropdown from "../../components/tags-dropdown/TagsDropdown";
import DateFilter from "../../components/filter/date-filter/DateFilter";
import DetectMobileHelper from "../../helpers/detect-mobile.helper";
import classes from "./Filters.module.scss";
import { resetAllTipFilters } from "../../../store/filters/tipFilters.slice";
import { Content } from "../../enums/Content";
import { RootState } from "../../../store";
import SaveTipFilters from "../../components/filter/save-filters/SaveTipFilters";
import AuthorFilter from "../../components/filter/author-filter.tsx/AuthorFilter";
import ContentLengthFilter from "../../components/filter/content-length-filter/ContentLengthFilter";
import { ContentLengthOptions } from "../../enums/ContentLengthOptions";

const TipFilters = () => {
  const tipFilters = useSelector(
    (state: RootState) => state.tipFilters.tipFilters
  );
  const dispatch = useDispatch();

  const renderButtons = useMemo(() => {
    const handleClearFilters = (event: React.MouseEvent<HTMLButtonElement>) => {
      dispatch(resetAllTipFilters());
    };

    const isSaveButtonVisible = Object.entries(tipFilters).some(([key, value]) => {
      if (key === 'date' || key === 'hasWords') {
        return false;
      }

      if (key === 'contentLength') {
        return value !== ContentLengthOptions.LONG;
      }

      if (Array.isArray(value)) {
        return value.length > 0;
      }

      return value !== null;
    });

    const isClearButtonVisible = Object.entries(tipFilters).some(
      ([key, value]) => {
        if (Array.isArray(value)) {
          return value.length > 0;
        }

        return value !== null && value !== ContentLengthOptions.LONG;
      }
    );

    return (
      <>
        <SaveTipFilters filters={tipFilters} hidden={!isSaveButtonVisible} />
        <Button
          className={`${classes.button} px-4 mt-2 mt-sm-0`}
          onClick={handleClearFilters}
          hidden={!isClearButtonVisible}
        >
          Clear All
        </Button>
      </>
    );
  }, [dispatch, tipFilters]);

  if (DetectMobileHelper.isMobile()) {
    return (
      <Box className="d-flex flex-column h-100 align-items-center justify-content-start w-100">
        <TagsDropdown content={Content.TIPS} />
        <AuthorFilter content={Content.TIPS} />
        {renderButtons}
      </Box>
    );
  }

  return (
    <Box className="d-flex flex-row gap-2">
      <TagsDropdown content={Content.TIPS} />
      <AuthorFilter content={Content.TIPS} />
      <ContentLengthFilter />
      <DateFilter content={Content.TIPS} />
      {renderButtons}
    </Box>
  );
};

export default TipFilters;
